import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import {aksEncode, aksDecode} from '@/utils/aks';

const vm = new Vue();

axios.defaults.baseURL = `${window.CONFIG.baseURL}/gw/generic/bt/h5/m/`;

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true;

function getChannelParams() {
  let params = {};
  if (window.CONFIG.getQueryFunc('channelName')) {
    params.channelName = window.CONFIG.getQueryFunc('channelName');
  }
  if (window.CONFIG.getQueryFunc('secondCode')) {
    params.secondCode = window.CONFIG.getQueryFunc('secondCode');
  }
  if (window.CONFIG.getQueryFunc('recommend')) {
    params.recommend = window.CONFIG.getQueryFunc('recommend');
  }
  return params;
}

function getResquestParams(data) {
  const channelParams = getChannelParams();
  return {
    bizCode: window.CONFIG.bizCode,
    sourceType: window.CONFIG.sourceType,
    ...channelParams,
    ...data
  };
}

axios.interceptors.request.use(
  async (config) => {
    let data = qs.stringify({
      reqData: JSON.stringify(getResquestParams(config.data))
    });
    if (config.isAks === true) {
      const params = await aksEncode(getResquestParams(config.data));
      data = 'reqData='+ JSON.stringify(params);
    }
    return Object.assign(
      {},
      config,
      {
        data
      }
    );
  },
  error => Promise.reject(error)
);

function showError(error) {
  vm.$vDialog.show(error);
  throw typeof error === 'string'
    ? error
    : error.contentHtml;
}

function jumpUrl(url, error) {
  window.location.href = url;
  throw error;
}

axios.interceptors.response.use(
  async (res) => {
    let data = res.data;
    if (res.config.isAks === true) {
      data = await aksDecode(data);
    }
    if (data.resultCode === 0) {
      if (res.config.isError === false) {
        return data;
      }
      const resultData = data.resultData;
      switch (resultData.result.code) {
        case 'SUCCESS':
          return data;
        
        case 'EXT_ACT_ERROR_00047':// 尝鲜白条
          vm.$tasteFresh.show({opened: false});
          throw '尝鲜白条需完善信息';
          
        case 'EXT_ACT_ERROR_00001':// 未激活白条
          showError({
            title: '',
            contentHtml: window.CONFIG.errorInfo.EXT_ACT_ERROR_00001,
            btns: [
              {
                name: '我知道了'
              },
              {
                name: '立即激活白条',
                callback: () => {
                  document.getElementById('jiHuoBaiTiao').click();
                  const returnUrl = window.location.href;
                  let redirectUrl = `//bt.jd.com/v3/mobile/rGuide_initGuideMobile?source=JD_zw&returnUrl=${
                    encodeURIComponent(returnUrl)
                  }`;
                  const channelParams = getChannelParams();
                  Object.keys(channelParams).forEach((key) => {
                    redirectUrl += `&${key}=${channelParams[key]}`;
                  });
                  window.location.href = redirectUrl;
                }
              }
            ]
          });
        
        case 'EXT_ACT_ERROR_00023':// 系统业务打烊
          showError({
            contentHtml: resultData.result.info,
            btns: [
              {
                name: '我知道了',
                callback: () => {
                  window.location.href = `${window.location.pathname + window.location.search}#/`;
                }
              }
            ]
          });
        
        case 'EXT_ACT_ERROR_00024':// 用户不在数据部名单中
        case 'EXT_ACT_ERROR_00025':// 白条账户类型不符
        case 'EXT_ACT_ERROR_00035':// 用户为次级授信用户，不可开通
        case 'EXT_ACT_ERROR_00036':// 用户为学生用户，不可开通
          showError({
            contentHtml: window.CONFIG.errorInfo.EXT_ACT_ERROR_00024,
            btns: [
              {
                name: '我知道了',
                callback: () => {
                  window.location.href = `${window.location.pathname + window.location.search}#/`;
                }
              }
            ]
          });
          
        case 'EXT_ACT_ERROR_00026':// 白条账户状态异常
          showError({
            contentHtml: window.CONFIG.errorInfo.EXT_ACT_ERROR_00026,
            btns: [
              {
                name: '我知道了',
                callback: () => {
                  window.location.href = `${window.location.pathname + window.location.search}#/`;
                }
              }
            ]
          });
          
        case 'EXT_ACT_ERROR_00027':// 高法拦截
          jumpUrl(`${window.location.pathname + window.location.search}#/status/failed`, resultData.result.info);
          
        case 'EXT_ACT_ERROR_00033':// 白条子账户已开通
          jumpUrl(`${window.location.pathname + window.location.search}#/home`, resultData.result.info);
          
        case 'EXT_ACT_ERROR_00037':// 用户状态审核中
          jumpUrl(`${window.location.pathname + window.location.search}#/status/checking-end?applyNo=${resultData.applyNo}`, resultData.result.info);
       
        case 'EXT_ACT_ERROR_00043':// 操作频繁
          showError('操作过于频繁，请稍后重试');
          
        default:
          if (res.config.isErrorDefault === false) {
            return data;
          }
          showError(window.CONFIG.error);
      }
    } else if (data.resultCode === 3) {
      if (res.config.isLogin === false) {
        return data;
      }
      const returnUrl = window.location.href;
      window.location.href = `
        //plogin.m.jd.com/user/login.action?appid=100&returnurl=${encodeURIComponent(returnUrl)}
      `;
    } else {
      showError(window.CONFIG.error);
    }
  },
  error => {
    showError(window.CONFIG.error);
  }
)

Vue.prototype.$http = axios;
